import Icon from '../../../../../../../../components/icon';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {msgSharingDetailsBar as setMsgSharingDetailsBar} from '../../../../../../../../../actions/msgBarActions';

function MsgSharingDetailsBar () {

	const msgSharingDetailsBar = useSelector(state => state.msgBarReducer.msgSharingDetailsBar);

	const dispatch = useDispatch();

	const handleClick = () => {
		dispatch(setMsgSharingDetailsBar([]));
	};

	return (
		<div className={`d-flex align-items-center justify-content-center msg-sharing-details-bar${msgSharingDetailsBar[0] ? ' ' + msgSharingDetailsBar[0] : ''}`}>
			{
				msgSharingDetailsBar[1]
					?
					<p className="m-0" dangerouslySetInnerHTML={{__html: msgSharingDetailsBar[1]}} />
					:
					''
			}
			<Icon onClick={handleClick} name="times"/>
		</div>
	)
}

export default MsgSharingDetailsBar;